import type { IJobs } from '@monofe/apiservice';
import type { IServiceWorkerController } from '@monofe/worker';
import type { IDataResolver } from '../interface';
import type { IModuleState } from '../state/interface';
import type { IModuleDialog } from './dialog';
import type { IModuleSession } from './session';
import type { IModuleToast } from './toast';
import { Message } from './toast';

const _hideViews = (deps: { store: IModuleState; dialog: IModuleDialog }) => {
    deps.dialog.hide();
    deps.store.action.hideProgressBar();
    deps.store.action.setProgress(0);
};

const _showProgress = (deps: { store: IModuleState; dialog: IModuleDialog }) => {
    deps.store.action.setProgress(0);
    deps.store.action.showProgressBar();
};

const onAccept = async (deps: {
    session: IModuleSession;
    toast: IModuleToast;
    store: IModuleState;
    dialog: IModuleDialog;
    serviceWorker: IServiceWorkerController;
    resolver: IDataResolver;
    jobs: IJobs;
}) => {
    _hideViews(deps);

    const state = deps.store.getState();
    const { userSession, languageId, tourId } = state;
    if (!userSession || !languageId || !tourId || languageId < 1 || tourId < 1) {
        return;
    }

    const session = await deps.session.session(userSession);

    const deletionList = await deps.resolver.downloadList();

    _showProgress(deps);

    const promise = deps.jobs.deleteMedia(session.media, deletionList);

    if (promise) {
        promise.onProgress(progress => {
            const newBarProgress = Math.round(progress * 100) / 100; /* 2dp accuracy */
            deps.store.action.setProgress(newBarProgress);
        });

        await promise
            .then(() => {
                deps.toast.show(Message.DeletionCompleted);
            })
            .catch(() => {
                deps.toast.show(Message.DeletionFailed_UnexpectedError);
            });
    } else {
        deps.toast.show(Message.DeletionFailed_UnexpectedError, ['Unknown error']);
    }

    deps.store.action.hideProgressBar();
};

export default onAccept;
